export const loadedPageParams = state => state.loadedPageParams;
export const loading = state => state.loading;
export const loadingText = state => state.loadingText;
export const loadingAnimationActive = state => state.loadingAnimationActive;
export const postLoadingText = state => state.postLoadingText;
export const postLoadingAnimation = state => state.postLoadingAnimation;
export const postLoadingAnimationActive = state =>
  state.postLoadingAnimationActive;
export const uiHeaderBackActive = state => state.uiHeaderBackActive;
export const uiHeaderText = state => state.uiHeaderText;
